import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-thumbs-up-icon',
  templateUrl: 'thumbs-up-icon.component.html'
})
export class ThumbsUpIconComponent {}
